export const parseToVND = (price: number | undefined) => {

    if (!price) {
        return 0
    }
    return `${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}